import React from 'react';
import './Partners.css';

// Import partner images
import yango from '../../assets/Images/partners/1.png';
import partner1 from '../../assets/Images/partners/2.png';
import partner2 from '../../assets/Images/partners/3.png';
import partner3 from '../../assets/Images/partners/4.png';
import partner4 from '../../assets/Images/partners/5.png';   

const Partners: React.FC = () => { 
  const partners = [yango, partner1, partner2, partner3, partner4,   ];

  return (
    <div className="partners-section"> 
      <div className="partners-row row1">
        {[...partners, ...partners].map((partner, index) => (
          <div key={index} className="partner-item">
            <img src={partner} alt={`Partner ${index + 1}`} className="partner-logo" />
          </div>
        ))}
      </div>
 
    </div>
  );
};

export default Partners;
